import { render } from "./VersionShow.vue?vue&type=template&id=4ea5711a&scoped=true"
import script from "./VersionShow.vue?vue&type=script&lang=js"
export * from "./VersionShow.vue?vue&type=script&lang=js"

import "./VersionShow.vue?vue&type=style&index=0&id=4ea5711a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea5711a"]])

export default __exports__